export default __webpack_public_path__ + "static/media/conteudo_extra_18_30.de2f0e8d.jpg";